import PropTypes from 'prop-types';
import type React from 'react';
import type { RouteProps } from 'react-router-dom';
import { Route, Redirect, useLocation } from 'react-router-dom';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

import { getLoginUrl } from '../../utils/url';

const AuthenticatedRoute: React.FC<RouteProps> = ({
  render,
  ...routeProps
}) => {
  const { isLoggedIn } = useLoginState();
  const location = useLocation();

  return isLoggedIn ? (
    <Route {...routeProps} render={render} />
  ) : (
    <Redirect to={getLoginUrl({ location: location.pathname })} />
  );
};

AuthenticatedRoute.propTypes = {
  render: PropTypes.func.isRequired,
};

export default AuthenticatedRoute;
